var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form"},[(!_vm.editedReportSettings)?_c('list',{attrs:{"data":_vm.roles,"edit":"","cases":{
      title: null,
    }},on:{"edit":_vm.editReport}}):_c('ReportSettingsForm',{attrs:{"report-settings":_vm.editedReportSettings},on:{"cancel":_vm.cancelEdit,"save":_vm.saveEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }